export default __webpack_public_path__ + "static/media/interrupted.3850713c.svg";